import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { applicationApi } from './applicationApi';
import { ApplicationList } from './applicationModels';

export const selectApplicationListRaw = (state: RootState) => applicationApi.endpoints.getApplicationList.select()(state);
export const selectApplicationRaw = (code: string) => (state: RootState) => applicationApi.endpoints.getApplication.select(code)(state);
export const selectApplicationEligibility = (applicationType: string) => (state: RootState) => applicationApi.endpoints.getApplicationEligibility.select(applicationType)(state);


export const selectApplicationListLoaded = createSelector(
  [selectApplicationListRaw],
  (slice) => slice.status === 'fulfilled'
);

export const selectApplicationListLoading = createSelector(
  [selectApplicationListRaw],
  (slice) =>  slice.isLoading
);

export const selectApplicationList = createSelector(
  [selectApplicationListRaw],
  ({ data }) => data as ApplicationList // []
);


// Single Application
export const selectApplicationLoaded = (code: string) =>
  createSelector(
    [selectApplicationRaw(code)],
    (slice) => slice?.status === 'fulfilled'
  );

export const selectApplicationLoading = (code: string) =>
  createSelector(
    [selectApplicationRaw(code)],
    (slice) => slice.isLoading
);

export const selectApplication = (code: string) =>
  createSelector(
    [selectApplicationRaw(code)],
    ({data}) => data
);

export const selectIsEligibleToSubmit = (applicationType: string) =>
  createSelector(
    [selectApplicationEligibility(applicationType)],
    ({data}) => data?.isEligible
  );

